import { render, staticRenderFns } from "./ReportDocumentReceptions.vue?vue&type=template&id=70f7e44a&scoped=true&"
import script from "./ReportDocumentReceptions.vue?vue&type=script&lang=js&"
export * from "./ReportDocumentReceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f7e44a",
  null
  
)

export default component.exports